import React from 'react';
import { getStatusText } from '../../utils/itemUtils';
import { formatItemCountLabel, formatRelativeTime } from '../../utils/venueUiFormatters';
import '../../styles/OrderCard.css';

const getChipVariant = (status) => {
  switch (status) {
    case 'pending':
      return 'pending';
    case 'preparing':
      return 'preparing';
    case 'completed':
      return 'completed';
    default:
      return 'neutral';
  }
};

const OrderCard = ({ order, onClick, showTable, showStatus, dragDisabled = false }) => {
  const hasNotes = Boolean(order?.notes || order?.items?.some((item) => item.notes));
  const previewItems = (order?.items || []).slice(0, 3);
  const remainingItemCount = Math.max((order?.items || []).length - previewItems.length, 0);
  const tableLabel = order?.tables?.name || 'Masa bilgisi bekleniyor';
  const handleActivate = () => onClick?.(order);
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleActivate();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={`order-card ${dragDisabled ? 'order-card--locked' : 'order-card--draggable'}`}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
    >
      <div className="order-card__top">
        <div>
          <p className="order-card__eyebrow">Sipariş #{order.id}</p>
          <h3 className="order-card__title">
            {showTable ? `Masa ${tableLabel}` : getStatusText(order.status)}
          </h3>
        </div>
        <div className="order-card__chips">
          {showStatus ? (
            <span className={`venue-chip venue-chip--${getChipVariant(order.status)}`}>
              {getStatusText(order.status)}
            </span>
          ) : null}
          {hasNotes ? (
            <span className="order-note-indicator" title="Siparişte not var">
              Not
            </span>
          ) : null}
        </div>
      </div>

      <div className="order-card__meta">
        <span>{formatItemCountLabel(order?.items || [])}</span>
        <span>{formatRelativeTime(order?.created_at)}</span>
      </div>

      <div className="order-items">
        {previewItems.map((item) => (
          <div key={item.orderItemId || item.id} className="order-item">
            <span className="order-item__quantity">{item.quantity}x</span>
            <span className="order-item__name">{item.name}</span>
          </div>
        ))}
        {remainingItemCount > 0 ? (
          <div className="order-card__more-items">+{remainingItemCount} ürün daha</div>
        ) : null}
      </div>
    </div>
  );
};

export default OrderCard;
